<template>
  <Container class="">
    <div
      class="flex flex-wrap items-end gap-6 border-gray-300 lg:flex-nowrap lg:justify-center lg:gap-8"
      :class="type === 'primary' ? '' : 'border-b pb-7'">
      <div
        class="w-full lg:w-auto"
        :class="{ 'text-gray-600': theme === 'light', 'text-white': theme === 'dark' }">
        <h2
          class="leading-tight"
          :class="[
            type === 'primary' ? 'text-5xl lg:text-6xl' : 'text-4xl lg:text-5xl',
            !cta ? 'max-w-3xl lg:text-center' : 'max-w-2xl'
          ]"
          v-html="refactored" />
        <div
          v-if="copy"
          class="mt-6 text-lg lg:mt-8"
          :class="[!cta ? 'max-w-3xl lg:text-center' : 'max-w-2xl']"
          v-html="copy" />
      </div>

      <ButtonBase
        v-if="cta"
        class="lg:ml-auto lg:flex-shrink-0"
        :type="cta.type"
        :theme="theme"
        :href="cta.href"
        :label="cta.title"
        @click="handleClick(cta)" />
    </div>
  </Container>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useRoute } from 'vue-router'
  import { useNuxtApp } from '#imports'

  import type { CtaType } from '../../../models/button'

  type SectionHeadingCtaProps = {
    theme?: 'dark' | 'light'
    title: string
    copy?: string
    cta?: CtaType
    type?: 'primary' | 'secondary'
  }

  const { title, theme = 'dark', type = 'primary', copy = '' } = defineProps<SectionHeadingCtaProps>()

  const refactored = computed(() => title.replace(/\n/g, ' <br class="hidden md:inline" />'))

  const { $event } = useNuxtApp()
  const route = useRoute()

  function handleClick(cta: CtaType) {
    if (!cta || !cta.title) {
      return
    }
    if (route.path.includes('for-media')) {
      return $event('Contact', { props: { 'Media page': cta.title } })
    }
  }
</script>

<style scoped>
  h2 strong {
    @apply text-red-500;
  }
</style>
